var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTreeRoundedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00A3E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9885 26.9438C14.4941 26.4411 11 22.6286 11 18C11 13.0294 15.0294 9 20 9C24.9706 9 29 13.0294 29 18C29 22.8067 25.2319 26.7332 20.4885 26.987L20.4885 32.25C20.4885 32.6642 20.1527 33 19.7385 33C19.3243 33 18.9885 32.6642 18.9885 32.25L18.9885 26.9438ZM18.9885 25.4324L18.9885 23C18.9885 22.5858 19.3243 22.25 19.7385 22.25C20.1527 22.25 20.4885 22.5858 20.4885 23L20.4885 25.4843C24.403 25.2327 27.5 21.978 27.5 18C27.5 13.8579 24.1421 10.5 20 10.5C15.8579 10.5 12.5 13.8579 12.5 18C12.5 21.7991 15.3247 24.9385 18.9885 25.4324Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeRoundedBlue);
export default __webpack_public_path__ + "static/media/tree-rounded-blue.cf884d67fa77d5dfabb9179fcd4a720d.svg";
export { ForwardRef as ReactComponent };